import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import Power6Stats from '../../components/Clubs/ClubProfile/TabContents/Power6Stats';
import * as actions from '../../actions/club-actions';
import { getClubGenderPower6 } from '../../utils/clubs';
import { setAuthHeader } from '../../actions';

const WebViewCollegeChart = (props) => {
    const parsed = queryString.parse(props.location.search);
    const { jwt } = parsed;
    console.log('jwt', jwt);
    if (jwt) {
        props.setAuthHeader({ jwt });
    }

    const getClub = async () => {
        await props.setClubId(props.match.params.clubId);
    };

    useEffect(() => {
        if (props.club.clubId !== props.match.params.clubId) {
            getClub();
        }
    }, [props.club.clubId]);

    const [clubDetails, setClubDetails] = useState({});
    const [power6Stats, setPower6Stats] = useState({});
    const [power6StatsState, setPower6StatsState] = useState({});

    useEffect(() => {
        setClubDetails(props.club.clubDetails);
        if (props.club.clubDetails?.clubSubType?.id) {
            const gender = getClubGenderPower6(props.club.clubDetails.clubSubType.id);
            if (!props.club.power6StatsState.loading && !props.club.power6StatsState.successful && !props.club.power6StatsState.completed && !props.club.power6StatsState.errorMessage) {
                if (gender === 'm' || gender === 'f') {
                    console.log('p6 loaded from page');
                    props.getPower6Stats({
                        conferenceId: props.club.clubDetails.schoolProfile.conferenceId,
                        gender,
                    });
                }
            }
        }
    }, [props.club.clubDetails, props.club.power6StatsState]);

    useEffect(() => {
        setPower6Stats(props.club.power6Stats);
        setPower6StatsState(props.club.power6StatsState);
    }, [props.club.power6Stats, props.club.power6StatsState]);

    const { club } = props;

    return (club?.clubDetailsFetched ? (
        <>
            {clubDetails.tierType?.isCollege && clubDetails.schoolProfile && (
                <Power6Stats
                    clubDetails={clubDetails}
                    power6Stats={power6Stats}
                    power6StatsState={power6StatsState}
                    getPower6Stats={props.getPower6Stats}
                    data-testid="webview.college-chart.power6-stats"
                />
            )}
        </>
    ) : null);
};

function mapDispatchToProps(dispatch) {
    return {
        setClubId: (clubId) => dispatch(actions.setClubId(clubId, true)),
        getPower6Stats: ({ conferenceId, gender }) => dispatch(actions.getPower6Stats({ conferenceId, gender })),
        setAuthHeader: ({ jwt }) => dispatch(setAuthHeader({ jwt })),
    };
}

function mapStateToProps({ club }) {
    return { club };
}

const component = compose(
    connect(mapStateToProps, mapDispatchToProps),
)(WebViewCollegeChart);

export default {
    component,
    loadData: ({ dispatch }, match) => dispatch(actions.getClubMetaData(match.params.clubId)),
};
